/* eslint-disable global-require, no-underscore-dangle, import/no-dynamic-require */

import { createElement } from 'react';
import dvaDynamic from 'dva/dynamic';

export const menuData = [{
  name: '首页',
  icon: 'home',
  path: 'home',

  model: ['home', 'promote', 'step'],
  page: () => import('../routes/Home/Dashboard'),
}, {
  name: '推广',
  icon: 'line-chart',
  path: 'promote',
  children: [{
    name: '计划',
    path: 'plan',

    model: ['promote'],
    page: () => import('../routes/Promote/Plan'),
  }, {
    name: '广告',
    path: 'ad',

    model: ['promote', 'step'],
    page: () => import('../routes/Promote/Ad'),
  }, {
    name: '创意',
    path: 'creativity',

    model: ['promote', 'step'],
    page: () => import('../routes/Promote/Creativity'),
  }, {
    name: '新建/编辑广告',
    path: 'create-step',
    hideInMenu: true,
    children: [{
      path: '/',

      model: ['step','tools', 'account'],
      page: () => import('../routes/Promote/CreateStep'),
    }, {
      path: 'confirm',

      model: ['step', 'tools' , 'account'],
      page: () => import('../routes/Promote/CreateStep'),
    }, {
      path: 'submit',

      model: ['step' , 'account'],
      page: () => import('../routes/Promote/CreateStep'),
    }],
  }],
}, {
  name: '报表',
  icon: 'pie-chart',
  path: 'report',
  children: [{
    name: '效果数据',
    path: 'effect',
    model: ['report'],
    page: () => import('../routes/Report/Effect'),
  },{
    name: '受众报表',
    path: 'audiences',
    dynamic: false,
    model: ['report'],
    page: () => import('../routes/Report/Audiences'),
  }],
}, {
  name: '财务',
  icon: 'wallet',
  path: 'finance',
  children: [{
    name: '财务信息',
    path: 'info',

    model: ['finance'],
    page: () => import('../routes/Finance/FinanceInfo'),
  }, {
    name: '财务记录',
    path: 'list',

    model: ['finance'],
    page: () => import('../routes/Finance/FinanceList'),
  }],
}, {
  name: '工具',
  icon: 'appstore-o',
  path: 'tools',
  children: [{
    name: '人群管理',
    path: 'crowd',

    model: ['step', 'tools'],
    page: () => import('../routes/Tools/Crowd'),
  }, {
    name: '转化跟踪',
    path: 'conversion',

    model: ['step', 'tools'],
    page: () => import('../routes/Tools/Conversion'),
  }, {
    name: '云音乐账号',
    path: 'account',
    enable: () => [700000002, 700000008, 700000007, 700000009, 700000010].includes((getUserInfo().userInfo || {}).sellerId),

    model: ['tools'],
    page: () => import('../routes/Tools/AccountCenter'),
  }, {
    name: '操作日志',
    path: 'sponsorLog',
    model: ['tools'],
    page: () => import('../routes/Tools/Log'),
  }, {
    name: 'APK包管理',
    path: 'apkCenter',
    model: ['tools'],
    page: () => import('../routes/Tools/ApkCenter'),
  }, {
    name: '图片库',
    path: 'adGenerator',
    dynamic: true,
    model: ['image'],
    page: () => import('../routes/Tools/AdGenerator'),
  }, {
    name: '视频库',
    path: 'videoLibrary',
    dynamic: true,
    model: ['image'],
    page: () => import('../routes/Tools/VideoWrap'),
  }, {
    name: '建站工具',
    path: 'builder',
    dynamic: false,
    model: ['builder', 'market'],
    page: () => import('../routes/Tools/Builder'),
  }],
}, {
  name: '账号管理',
  icon: 'appstore-o',
  path: 'account',
  dynamic: false,
  children: [{
    name: '品牌管理',
    path: 'brand',
    dynamic: true,

    model: ['account'],
    page: () => import('../routes/Account/Brand'),
  }, {
    name: '账户信息',
    path: 'info',
    model: ['account'],
    page: () => import('../routes/Account/Info'),
  }],
}, {
  name: '异常页',
  icon: 'warning',
  path: 'exception',
  hideInMenu: true,
  children: [{
    name: '403',
    path: '403',

    page: () => import('../routes/Exception/403'),
  }, {
    name: '404',
    path: '404',

    page: () => import('../routes/Exception/404'),
  }, {
    name: '500',
    path: '500',

    page: () => import('../routes/Exception/500'),
  }, {
    name: '触发异常',
    path: 'trigger',

    model: ['error'],
    page: () => import('../routes/Exception/triggerException'),
  }],
}, {
  name: '账户',
  icon: 'user',
  path: 'user',
  dynamic: false,
  hideInMenu: true,
  children: [{
    name: '登录',
    path: 'login',

    model: ['user'],
    page: () => import('../routes/User/Login'),
  }],
}, {
  name: '首页',
  path: 'index',
  dynamic: false,
  hideInMenu: true,

  model: ['home'],
  page: () => import('../layouts/BlankLayout'),
}, {
  name: '云音乐账号绑定',
  path: 'accountbind',
  dynamic: false,
  hideInMenu: true,

  model: ['tools'],
  page: () => import('../layouts/BindLayout'),
},{
  name: '帮助中心',
  icon: 'appstore-o',
  dynamic: false,
  redirectUrl: 'http://docs.popo.netease.com/lingxi/af36b10065924d8fa358861a0c22b655',
  model: ['tools'],
}];

export const formatPath = path => path.replace(/\/+/g, '/')

const getUserInfo = () => JSON.parse(sessionStorage.getItem('userInfo') || '{}') || {}

const authorizedRouterSet = () => {
  const { roleMenuList } = getUserInfo()
  const platformMenuList = (roleMenuList || []).filter(menu => menu.platformType === 'SPONSOR')
  const menuMap = platformMenuList.reduce((output, menu) => ({ ...output, [menu.menuId]: menu }), {})

  const menuPath = menu => {
    if (!menu) return null
    const parentId = (menu.parent || {}).menuId
    const current = [menu.url]
    if (!parentId) return current
    const parentPath = menuPath(menuMap[parentId])
    if (!parentPath) return null // 父级无授权
    return parentPath.concat(current)
  }

  return new Set(
      platformMenuList
        .map(menu => menuPath(menu))
        .filter(path => path)
        .map(path => formatPath(path.join('/')))
    )
}

// 仅页面懒加载
const dynamicImport = (app, menu, extra) => {
  // return props => createElement(menu.page().default, { ...props, ...extra }) // 同步 require
  return dvaDynamic({
    app,
    // models: () => menu.model.map(name => import(`../models/${name}`)),
    // 子组件 connect 取不到 state，因未在 page 注册 model，改动范围过大，无法保证正确行
    component: () => menu.page().then(page => {
      const component = page.default || page
      return props => createElement(component, { ...props, ...extra });
    }),
  })
}

export const generateMenuRouter = app => {
  const authorized = authorizedRouterSet()
  const routerData = {}
  const models = new Set([])

  const checkMenus = (prefix, menus, dynamic) => {
    return menus.reduce((output, menu) => {
      const absolutePath = formatPath([prefix, menu.path].join('/'))
      const check = ('dynamic' in menu) ? menu.dynamic : dynamic // 除非显式设置，否则继承自父菜单
      if (typeof(menu.enable) === 'function' && !menu.enable()) return output
      if (check && !authorized.has(absolutePath)) return output
      const children = menu.children ? checkMenus(absolutePath, menu.children, check) : null
      if (menu.page) routerData[absolutePath] = { ...menu, component: dynamicImport(app, menu) }
      if (menu.model) menu.model.forEach(models.add, models)
      return output.concat({ ...menu, children, path: absolutePath })
    }, [])
  }

  const checkedMenuData = checkMenus('/', menuData, true)
  const registeredModels = new Set(app._models.map(model => (model || {}).namespace).filter(Boolean))

  Array.from(models)
    .filter(model => !registeredModels.has(model)) // 排除已注册 model (hmr)
    .forEach(name => app.model(require(`../models/${name}`).default)) // 同步注册所有 model

  return {
    menuData: checkedMenuData,
    routerData,
  }
}
